import { GeoAddress } from "@/types";
import { getData } from "./axios-service";

function modelMapper(inputAddress: any): GeoAddress {
    return {
        id: inputAddress.id,
        line1: inputAddress.line1,
        line2: inputAddress.line2,
        city: inputAddress.city,
        postalCode: inputAddress.postalCode,
        longitude: inputAddress.longitude,
        latitude: inputAddress.latitude
    };
}

export function fetchGeoAddress(id: string): Promise<GeoAddress> {
    return getData("/addresses/" + id).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}